import React from "react";
import Navbar from "../components/Navbar";
import HeroSection from "../components/HeroSection";
import AnnouncementBar from "../components/AnnouncementBar";
import FreeQuoteBanner from "../components/FreeQuoteBanner";
import EstimationForm from "../components/EstimationForm";
import ServicesSection from "../components/ServicesSection";
import StatsSection from "../components/StatsSection";
import TechShowcase from "../components/TechShowcase";
import TestimonialSection from "../components/TestimonialSection";
import NewsSection from "../components/NewsSection";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";
import FloatingButtons from "../components/FloatingButtons";

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <FreeQuoteBanner />
      <HeroSection />
      <EstimationForm />
      <ServicesSection />
      <StatsSection />
      <TechShowcase />
      <TestimonialSection />
      <NewsSection />
      <ContactSection />
      <Footer />
      <FloatingButtons />
    </div>
  );
};

export default Home;